// extracted by mini-css-extract-plugin
export default {"section":"add-ons-section_section__wCUR+","mainSection":"add-ons-section_mainSection__gQFYw"};